import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-pin-code-input",
	templateUrl: "./pin-code-input.component.html",
	styleUrls: ["./pin-code-input.component.scss"],
	host: { "[attr.tabindex]": "-1" },
})
export class PinCodeInputComponent implements AfterViewInit {
	constructor(
		private elementRef: ElementRef<HTMLElement>,
		public rideOpsUi: RideOpsUiService,
	) {}

	@Input() pin = "";
	@Output() done = new EventEmitter<string>();

	add = (digit: number): void => {
		if (this.pin.length >= 4) {
			return;
		}

		if (this.pin.length < 4) {
			this.pin = this.pin + digit;
		}

		if (this.pin.length === 4) {
			this.done.emit(this.pin);
		}
	};
	clear = (): void => {
		this.pin = "";
	};
	delete = async () => {
		this.pin = this.pin.slice(0, this.pin.length - 1);
	};
	ngAfterViewInit(): void {
		setTimeout(() => this.elementRef.nativeElement.focus(), 100);
	}

	@HostListener("keydown", ["$event"])
	onKeyDown(event: KeyboardEvent): void {
		if (event.ctrlKey || event.metaKey || event.altKey) {
			return;
		}
		if (event.key >= "0" && event.key <= "9" && event.key.length === 1) {
			this.add(parseInt(event.key, 10));
			event.preventDefault();
			return;
		}
		if (event.key === "Backspace") {
			this.delete();
			event.preventDefault();
			return;
		}
		if (event.key === "Escape") {
			this.clear();
			event.preventDefault();
			event.stopPropagation();
			return;
		}
	}
}
